import React, {useState} from 'react';
import "./RewardResponsive.scss";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import clubBanner from "../../assets/images/club_banner_1.jpg";
import clubGiftIcon from "../../assets/images/club_gift_icon.png"
import clubBoxIcon from "../../assets/images/club_box_icon.png"
import clubCoinIcon from "../../assets/images/club_coin_icon.png";


import {EditOutlined} from '@ant-design/icons';
import {AwardsReceiveApi, getAwardConditionsApi} from "../Awards/AwardsService";
import toaster from "toasted-notes";
import {Modal, Popconfirm, Spin} from "antd";
import QRCode from "react-qr-code";
import motorImage from "../../assets/images/motor.png";
import basketImage from "../../assets/images/basket.png";

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function RewardResponsive({
                              awardCount,
                              couponCount,
                              history,
                              InvCard,
                              getReportPage,
                              getRewardsPage,
                              merchantId,
                              InvCard_skeleton,
                              showRewardM,
                              setGlobalPage,
                              load,
                              user,
                              award,
                              awardItems,
                              RewardHistoryCard,
                              rewardsHistory,
                              selectedReport,
                              RewardCard,
                              invo,
                              campaign,
                              getFactorDetail,
                              creditCard,
                              globalActiveTab,
                              set_activeTab,
                              activeTab,
                              rewards
}){

    const AwardCard = ({item,merchant})=>{


        //scroll detection


        //-----------------------------

        const [modalz, set_modalz] = useState(false);
        const [finalModalz, set_finalModalz] = useState(false);

        const showModal = () => {
            set_modalz(true);
        };

        const handleOk = () => {
            set_modalz(false);
        };

        const handleCancel = () => {
            set_modalz(false);
        };



        const handleFinalOk = () => {
            set_finalModalz(false);
        };

        const handleFinalCancel = () => {
            set_finalModalz(false);
        };

        const [instruction,set_instruction] = useState({})


        const awardBuy = async () => {
            set_spinModal(true)
            try{
                const res = await AwardsReceiveApi(merchant.uid,item.uid)
                set_earnedCode(res.data.code)
                set_modalz(false)
                set_finalModalz(true)
                set_spinModal(false)
            }catch (e) {
                switch (e.response.data.code) {
                    case 'you_dont_have_enough_scores_to_use_this_award':
                        toaster.notify(({ onClose }) => (<Error   message={"شما امتیاز کافی برای خرید این جایزه را ندارید"}/>),{duration: 2000});
                        break;
                    case 'there_is_no_available_award':
                        toaster.notify(({ onClose }) => (<Error   message={"در حال حاضر امکان خرید نمی باشد"}/>),{duration: 2000});
                        break;
                    default:
                        toaster.notify(({ onClose }) => (<Error   message={"مشکلی پیش آمده است"}/>),{duration: 2000});

                }
                set_spinModal(false)
            }
        };

        const awardConditions = async () => {
            set_spinCard(true)
            try{
                const res = await getAwardConditionsApi(merchant.uid,item.uid)
                set_modalz(true)
                set_spinCard(false)
                set_instruction(res.data)
            }catch (e) {
                set_spinCard(false)
                console.log(e)
            }
        };

        const [spinCard,set_spinCard] = useState(false)
        const [spinModal,set_spinModal] = useState(false)
        const [earnedCode,set_earnedCode] = useState(false)



        return(
            <div className="awards-item" >

                <Modal footer={null}  visible={finalModalz} onOk={handleFinalOk} onCancel={handleFinalCancel}>
                    <div className="award-result-modal">
                        <div className="award-result-modal-logo">
                            <img src="/other/award_logo.jpg" alt=""/>
                        </div>

                        <div className="award-result-modal-title">
                            <span>تبریک ,  جایزه خدمت شما</span>
                        </div>

                        <div className="award-result-modal-message">
                            <p>جوایز از همین قسمت قابل دیدن و استفاده اند و نیازی به یادداشت کد تخفیف نیست . </p>
                        </div>


                        {/*<div className="award-result-modal-list">*/}
                        {/*    <div className="award-result-modal-item">*/}
                        {/*        <span style={{*/}
                        {/*            color:"red"*/}
                        {/*        }}>{item.date}</span>*/}
                        {/*        <span>مدت زمان اعتبار</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="award-result-modal-qr">

                            <div className="award-result-modal-qr-row">
                                <span className="award-result-modal-qr-code">{earnedCode}</span>
                                <span>کد جایزه</span>
                            </div>

                            <div className="award-result-modal-qrcode">
                                <QRCode size={128} value={earnedCode} />
                            </div>

                        </div>

                    </div>
                </Modal>

                <Modal footer={null}  visible={modalz} onOk={handleOk} onCancel={handleCancel}>
                    <Spin spinning={spinModal}>
                        <div className="access-modal">
                            <div className="award-modal-header">
                                <div className="award-modal-header-row">
                                    <div className="award-modal-header-img">
                                        <img src={item.image} alt=""/>
                                    </div>
                                </div>
                                <div className="award-modal-header-row">
                                    <div className="award-modal-header-title">
                                        <span>{item.title}</span>
                                    </div>
                                </div>
                                <div className="award-modal-header-row">
                                    <span className="award-modal-header-point">{item.required_points} امتیاز مورد نیاز</span>
                                </div>
                            </div>

                            <div className="award-modal-body">

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>توضیحات</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.description}</p>
                                    </div>
                                </div>

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>شرایط استفاده</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.usage_condition}</p>
                                    </div>
                                </div>

                                <div className="award-modal-body-item">
                                    <div className="award-modal-item-title">
                                        <span>نحوه استفاده</span>
                                    </div>
                                    <div className="award-modal-item-text">
                                        <p>{instruction.instruction}</p>
                                    </div>
                                </div>

                                {/*<div className="award-modal-body-item">*/}
                                {/*    <div className="award-modal-item-title">*/}
                                {/*        <span>لازم به ذکر است </span>*/}
                                {/*    </div>*/}
                                {/*    <div className="award-modal-item-text">*/}
                                {/*        <p>با دریافت جایزه امتیاز کسر شده قابل بازگشت نیست</p>*/}
                                {/*        <p>برای اطلاعات بیشتر می توانید با قسمت چت فروشگاه تماس بگیرید</p>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                <div className="award-float-btn" onClick={()=>{
                                    awardBuy()
                                }}>
                                    <span>دریافت جایزه</span>
                                </div>

                            </div>

                        </div>
                    </Spin>

                </Modal>
                <Spin spinning={spinCard}>
                    <div onClick={()=>{
                        awardConditions()
                    }}>
                        <div className="awards-item-header">
                            <img src={item.image} alt=""/>
                        </div>
                        <div className="awards-item-body">
                            <div className="awards-item-text">
                                <div className="lottery-badg">{item.award_type==="campaign_lottery_point"?<span>امتیاز قرعه کشی : {item.related_campaign.title}</span>:null}</div>
                                <span>{item.title}</span>
                            </div>
                            <div className="awards-item-date">
                                {/*<span>{item.date}</span>*/}
                            </div>
                        </div>
                        <div className="awards-item-footer">
                            <div className="award-rotated-half-up-circle"></div>
                            <div className="award-rotated-half-down-circle"></div>
                            <span>جزییات</span>
                            <span style={{direction:"rtl"}}> {item.required_points} امتیاز </span>
                        </div>
                    </div>
                </Spin>
            </div>
        )
    }


    return(
        <div>


            <DrShopHeader home={true}/>

            <div className="club-page">

                <div className="club-page-offset"></div>

                <div className="club-page-main">

                    {/*Banner*/}
                    <div className="club-page-main-banner">
                        <img src={clubBanner} alt=""/>
                    </div>


                    {/*Statistic*/}
                    <div className="club-page-main-statistic section-border">

                        <div className="club-page-main-statistic-item" onClick={()=>{
                            window.currentPage = 1;
                            setGlobalPage(1)
                            set_activeTab("reward")
                            globalActiveTab = "reward"
                        }}>
                            <div className="club-page-main-statistic-item-info">
                                <span className="club-page-main-statistic-item-title">{couponCount} کوپن فعال</span>
                                {/*<span className="club-page-main-statistic-item-subtitle">3 روز مانده به انقضاء</span>*/}
                            </div>
                            <div className="club-page-main-statistic-item-icon">
                                <img src={clubGiftIcon} alt=""/>
                            </div>
                        </div>

                        <div className="club-page-main-statistic-item" onClick={e=>{
                            window.currentPage = 1;
                            setGlobalPage(1)
                            set_activeTab("campaign");
                            globalActiveTab = "campaign"
                        }}>
                            <div className="club-page-main-statistic-item-info">
                                <span className="club-page-main-statistic-item-title">جشنوار ها</span>
                                <span className="club-page-main-statistic-item-subtitle">{campaign.length} جشنواره فعال</span>
                            </div>
                            <div className="club-page-main-statistic-item-icon">
                                <img src={clubCoinIcon} alt=""/>
                            </div>
                        </div>

                        <div className="club-page-main-statistic-item"  onClick={()=>{
                            window.currentPage = 1;
                            setGlobalPage(1)
                            set_activeTab("award");
                            globalActiveTab = "award"
                        }}>
                            <div className="club-page-main-statistic-item-info">
                                <span className="club-page-main-statistic-item-title">جوایز و امتیازات</span>
                                <span className="club-page-main-statistic-item-subtitle"> {awardCount} جایزه قابل دریافت</span>
                            </div>
                            <div className="club-page-main-statistic-item-icon">
                                <img src={clubBoxIcon} alt=""/>
                            </div>
                        </div>

                    </div>


                    {/*Body*/}
                    <div className="club-page-main-body section-border">


                        {/*new tabs*/}
                        {/*<div className="new-tabs">*/}
                        {/*    <div  className={activeTab==="order"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}*/}

                        {/*          onClick={()=>{*/}
                        {/*              window.currentPage = 1;*/}
                        {/*              set_activeTab("order")*/}
                        {/*              globalActiveTab = "order"*/}

                        {/*          }} >*/}
                        {/*        {activeTab==="order"?<img src="/other/order_tab_selected.png" alt=""/>:<img src="/other/order_tab_default.jpg" alt=""/>}*/}
                        {/*        <span>سفارش ها</span>*/}
                        {/*    </div>*/}
                        {/*    <div className={activeTab==="reward_history"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}*/}

                        {/*         onClick={()=>{*/}
                        {/*             window.currentPage = 1;*/}
                        {/*             set_activeTab("reward_history")*/}
                        {/*             globalActiveTab = "reward_history"*/}
                        {/*         }} >*/}
                        {/*        {activeTab==="reward_history"?<img src="/other/history_tab_selected.png" alt=""/>:<img src="/other/history_tab_default.png" alt=""/>}*/}
                        {/*        <span>تاریخچه امتیازها</span>*/}
                        {/*    </div>*/}
                        {/*    <div*/}
                        {/*        className={activeTab==="reward"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}*/}
                        {/*        onClick={()=>{*/}
                        {/*            window.currentPage = 1;*/}
                        {/*            set_activeTab("reward")*/}
                        {/*            globalActiveTab = "reward"*/}
                        {/*        }}>*/}
                        {/*        {activeTab==="reward"?<img src="/other/reward_tab_selected.png" alt=""/>:<img src="/other/reward_tab_default.png" alt=""/>}*/}
                        {/*        <span>تخفیف ها</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}


                        {/*rewards & order tabs */}
                        <div className="tabs">


                            {activeTab==="reward"?
                                <div className="rewards-tab">
                                    <div className="rewards-tab-list">
                                        <div className="order-title">
                                            <span>کوپن ها</span>
                                        </div>
                                        {rewards.map(i=>{
                                            return(
                                                <RewardCard getRewardsPage={getRewardsPage} showModal={showRewardM} item={i}/>
                                            )
                                        })}
                                    </div>
                                </div>:null}

                            {activeTab==="campaign"?
                                <div className="rewards-tab">
                                    <div className="order-title">
                                        <span>جشنواره ها</span>
                                    </div>
                                    <div className="festival-con">
                                        {campaign.map(item=>{
                                            return(
                                                <>
                                                    {item.is_featured?
                                                        <div className="festival-item-single" onClick={()=>{
                                                            history.push(`/festival-detail/${item.uid}`,{festival:item})
                                                        }}
                                                        >
                                                            <img src={item.cover || item.image || "/other/skeleton/slide.jpg"} alt=""/>
                                                            <span>{item.title}</span>
                                                        </div>:
                                                        <div className="festival-item-dual" onClick={()=>{
                                                            history.push(`/festival-detail/${item.uid}`,{festival:item})
                                                        }}>
                                                            <img src={item.cover || item.image || "/other/skeleton/product.jpg"} alt=""/>
                                                            <span>{item.title}</span>
                                                        </div>
                                                    }
                                                </>

                                            )
                                        })}
                                    </div>
                                </div>:null}


                            {activeTab==="award"?<div className="awards-items-sec">
                                <div className="order-title">
                                    <span>جوایز و امتیازات</span>
                                </div>
                                <div className="awards-items-list">
                                    {award.map(d=>{
                                        return(
                                            <AwardCard item={d} merchant={merchantId} />
                                        )
                                    })}

                                </div>
                            </div>:null}


                            {activeTab==="reward_history"?
                                <div className="rewards-tab">
                                    <div className="rewards-tab-list">
                                        {rewardsHistory.map(i=>{
                                            return(
                                                <RewardHistoryCard showModal={showRewardM} item={i}/>
                                            )
                                        })}
                                    </div>
                                </div>:null}

                            {activeTab==="order"?
                                <>
                                    <div className="order-title">
                                        <span>سفارشات</span>
                                    </div>
                                    <div className="orders-tab">

                                        <div className="orders-tab-col">
                                            <img src={motorImage} alt=""/>
                                        </div>
                                        <div className="orders-tab-list">
                                            {selectedReport === "cat" ? <div className="cat-list">
                                                {invo.length < 1 ?
                                                    <>
                                                        <InvCard_skeleton show={load}/>
                                                    </>
                                                    : null}
                                                {invo.map(item => {
                                                    return (
                                                        <InvCard item={item} getReportPage={getReportPage} getFactorDetail={getFactorDetail}/>
                                                    )
                                                })}
                                            </div> : null}
                                        </div>
                                        <div className="orders-tab-col">
                                            <img src={basketImage} alt=""/>
                                        </div>
                                    </div>
                                </>
                                :null
                            }


                        </div>

                    </div>

                </div>


                {/*Menu*/}
                <div className="club-page-menu section-border">

                    <div className="club-page-menu-header">
                        <div className="club-page-menu-header-edit" onClick={e=>{
                            history.push("/profile")
                        }}>
                            <EditOutlined />
                        </div>

                        <div className="club-page-menu-header-info">
                            <span className="club-page-menu-header-info-name">{user && user.first_name ? user.first_name+" "+user.last_name:"" }</span>
                            <span className="club-page-menu-header-info-mobile">{user && user.phone ? user.phone:"" }</span>
                        </div>

                    </div>

                    {/*<div className="club-page-menu-header-row" onClick={()=>{*/}
                    {/*    window.currentPage = 1;*/}
                    {/*    setGlobalPage(1)*/}
                    {/*    set_activeTab("message");*/}
                    {/*    globalActiveTab = "message"*/}
                    {/*}}>*/}

                    {/*    <div className="club-page-menu-header-row-badge">*/}
                    {/*        <span>4</span>*/}
                    {/*    </div>*/}

                    {/*    <div className="club-page-menu-header-row-label" >*/}
                    {/*        <span>پیامها</span>*/}
                    {/*    </div>*/}

                    {/*</div>*/}


                    <div className="club-page-menu-header-row" onClick={()=>{
                        window.currentPage = 1;
                        setGlobalPage(1)
                        set_activeTab("campaign");
                        globalActiveTab = "campaign"
                    }}>

                        <div className="club-page-menu-header-row-badge">
                            {1===2?<span></span>:null}
                        </div>

                        <div className="club-page-menu-header-row-label" >
                            <span>جشنواره ها</span>
                        </div>

                    </div>


                    {/*<div className="club-page-menu-header-row" onClick={()=>{*/}
                    {/*    window.currentPage = 1;*/}
                    {/*    setGlobalPage(1)*/}
                    {/*    set_activeTab("reward_history")*/}
                    {/*    globalActiveTab = "reward_history"*/}
                    {/*}}>*/}

                    {/*    <div className="club-page-menu-header-row-badge">*/}
                    {/*        {1===2?<span></span>:null}*/}
                    {/*    </div>*/}
                    {/*    <div className="club-page-menu-header-row-label" >*/}
                    {/*        <span>امتیازات</span>*/}
                    {/*    </div>*/}


                    {/*</div>*/}




                    <div className="club-page-menu-header-row"  onClick={()=>{
                        window.currentPage = 1;
                        setGlobalPage(1)
                        set_activeTab("award");
                        globalActiveTab = "award"
                    }}>


                        <div className="club-page-menu-header-row-badge">
                            {1===2?<span></span>:null}
                        </div>

                        <div className="club-page-menu-header-row-label">
                            <span>جایزه ها</span>
                        </div>


                    </div>

                    <div className="club-page-menu-header-row"  onClick={()=>{
                        window.currentPage = 1;
                        setGlobalPage(1)
                        set_activeTab("order")
                        globalActiveTab = "order"

                    }}>


                        <div className="club-page-menu-header-row-badge">
                            {1===2?<span></span>:null}
                        </div>
                        <div className="club-page-menu-header-row-label"  >
                            <span>سفارشات</span>
                        </div>


                    </div>

                    <div className="club-page-menu-header-row"   onClick={()=>{
                        window.currentPage = 1;
                        setGlobalPage(1)
                        set_activeTab("reward")
                        globalActiveTab = "reward"
                    }}>


                        <div className="club-page-menu-header-row-badge">
                            {1===2?<span></span>:null}
                        </div>
                        <div className="club-page-menu-header-row-label" >
                            <span>کوپن ها</span>
                        </div>
                    </div>


                    <div className="club-page-menu-header-row">


                        <div className="club-page-menu-header-row-badge">
                            {1===2?<span></span>:null}
                        </div>

                        <div className="club-page-menu-header-row-label">
                            <Popconfirm
                                title="آیا شما از خروج از حساب کاربری خود اطمینان دارید ؟"
                                onConfirm={e=>{
                                    localStorage.clear();
                                    history.push("/login")
                                }}
                                onCancel={e=>{
                                    console.log("cancel")
                                }}
                                okText="بله"
                                cancelText="خیر"
                            >
                                <span  className="logout-link" >خروج از حساب کاربری</span>
                            </Popconfirm>
                        </div>


                    </div>




                </div>

                <div className="club-page-offset"></div>

            </div>

            <div className="reward-responsive-container">
                <div className="reward-body">
                    {/*Credit Card*/}
                    {/*<div className="creditCard" style={{backgroundColor:"rgb(207 207 207)"}}>*/}
                    {/*<div className="creditCard" style={{backgroundImage: `url(${creditCard.image})`}}>*/}

                    {/*    <div className="card-title-sec" >*/}
                    {/*        <span style={{color:`#${creditCard.title_color?creditCard.title_color:"#ffffff"}`}}>{creditCard.title}</span>*/}
                    {/*    </div>*/}

                    {/*    /!*<div className="card-log-sec">*!/*/}
                    {/*    /!*    <img src={creditCard.image}  style={{width:100,height:100,padding:24}} alt="" />*!/*/}
                    {/*    /!*</div>*!/*/}

                    {/*    /!*<div className="rewardCard-logo">*!/*/}
                    {/*    /!*    /!*<img src="/other/reward/reward_logo.svg" alt=""/>*!/*!/*/}
                    {/*    /!*    <img src={creditCard.image} alt="" />*!/*/}
                    {/*    /!*</div>*!/*/}

                    {/*    /!*<div className="rewardCard_name" style={{color:`#${creditCard.title_color?creditCard.title_color:"#ffffff"}`}}>*!/*/}
                    {/*    /!*    <span>{creditCard.title}</span>*!/*/}
                    {/*    /!*</div>*!/*/}

                    {/*    <div className="rewardCard-info" onClick={()=>{*/}
                    {/*        history.push("/profile")*/}
                    {/*    }}>*/}
                    {/*        /!*<span>{creditCard.uid?creditCard.uid:"---"}</span>*!/*/}
                    {/*        <span style={{color:`#${creditCard.name_color?creditCard.name_color:"#ffffff"}`}}>{user && user.first_name ? user.first_name+" "+user.last_name:"نام خود را وارد نمایید"  }</span>*/}
                    {/*    </div>*/}

                    {/*    <div className="rewardCard-credit">*/}
                    {/*        <span style={{color:`#${creditCard.point_color?creditCard.point_color:"#ffffff"}`}}>موجودی : {creditCard.uid?creditCard.card_points:"-"} امتیاز</span>*/}
                    {/*    </div>*/}

                    {/*</div>*/}


                    {/*{festivalsStatus?<div className="reward-banner" onClick={e=>{*/}
                    {/*    history.push("/festivals")*/}
                    {/*}}>*/}
                    {/*    <img src="https://s3.mobank.co/loyalty-media/page/section_item/images/Group_3548_SYwCIa7.png" alt=""/>*/}
                    {/*</div>:null}*/}


                    {/*Options list*/}
                    {/*<div className="options-list">*/}
                    {/*    <div className="options-item reward-question-btn" onClick={()=>history.push("/festivals",{credit:creditCard})}>*/}
                    {/*        /!*<img src="/other/reward/reward_q.svg" alt=""/>*!/*/}
                    {/*        <img src="/other/sample1.gif" alt=""/>*/}
                    {/*        <span>جشنواره ها</span>*/}
                    {/*    </div>*/}
                    {/*    <div className="options-item reward-gift-btn"*/}
                    {/*         onClick={()=>history.push("/awards")}*/}
                    {/*    >*/}
                    {/*        /!*<img src="/other/reward/reward_gift.svg" alt=""/>*!/*/}
                    {/*        <img src="/other/sample2.gif" alt=""/>*/}
                    {/*        <span>جایزه ها</span>*/}
                    {/*    </div>*/}
                    {/*</div>*/}







                </div>
            </div>


            <FooterDesktop/>
        </div>
    )
}

export default RewardResponsive
